export const isAbsoluteUrl = (value: string): boolean => {
  return /^https?:\/\//i.test(value);
};

export const normalizePath = (path: string): string => {
  return path.startsWith('/') ? path : `/${path}`;
};

export const appendQueryParams = (
  url: URL,
  params: Record<string, string | number | boolean | undefined>,
): void => {
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined) {
      return;
    }
    url.searchParams.set(key, String(value));
  });
};
